import {Helmet} from "react-helmet";

export default function Business() {
    return (
        <div>
            <p>
                <Helmet>
                    <script
                        type="text/javascript"
                        src="https://cdns.gigya.com/JS/gigya.js?apiKey=3_GE23JX1gIDl0aJB2e9TaRhVZyxcaF8xLpfvRTj1HxjC6Gs_KSNZOOAbSCwueaCpd&lang=en-gb">
                    </script>
                    <script
                        type="text/javascript"
                        src="//cdn.gigya-ext.com/gy.js">
                    </script>
                </Helmet>
                <div className="gy-ui-screen-set" data-screen-set="ULVR_prefCentre_v1"></div>
            </p>
        </div>
    );
}
